import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer id="soporte" className="bg-[#12263A] text-[#F3F2F2]">
      <div className="max-w-6xl mx-auto px-5 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="bg-[#F3F2F2] inline-flex px-3 py-2 rounded-[16px] border-2 border-[#12263A]">
            <Logo size={34} />
          </div>
          <p className="mt-4 text-[15px] text-[#D6D9DC] leading-[1.6]">Siempre cerca, aunque no estés.</p>
        </div>

        <FooterCol
          title="Producto"
          items={[
            { label: "Ubicación", href: "#producto" },
            { label: "Zonas seguras", href: "#producto" },
            { label: "Botón SOS", href: "#producto" },
            { label: "Precios", href: "#precios" },
          ]}
        />
        <FooterCol
          title="Empresa"
          items={[
            { label: "Cómo funciona", href: "#como-funciona" },
            { label: "Soporte", href: "#soporte" },
            { label: "Contacto", href: "#soporte" },
          ]}
        />
        <FooterCol
          title="Legal"
          items={[
            { label: "Privacidad", to: "/privacidad" },
            { label: "Términos", to: "/terminos" },
            { label: "Cookies", to: "/privacidad#cookies" },
          ]}
        />
      </div>

      <div className="border-t-2 border-[#2A3D52]">
        <div className="max-w-6xl mx-auto px-5 py-6 flex flex-col sm:flex-row justify-between gap-3 text-[13px] text-[#6E7B8B]">
          <span>© {new Date().getFullYear()} Kiddio. Tus datos y los de tu familia siempre son tuyos.</span>
          <span>Sin redes sociales. Sin publicidad. Sin rastreo comercial.</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#2E9EF0]">{title}</p>
      <ul className="mt-4 space-y-2">
        {items.map((i) => (
          <li key={i.label}>
            {i.to ? (
              <Link
                to={i.to}
                data-testid={`footer-link-${i.label.toLowerCase()}`}
                className="text-[15px] text-[#D6D9DC] hover:text-white transition-colors"
              >
                {i.label}
              </Link>
            ) : (
              <a href={i.href} className="text-[15px] text-[#D6D9DC] hover:text-white transition-colors">
                {i.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
